module.exports = __webpack_public_path__ + "static/media/news3.105bd3cf.png";